import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { HttpService, LocalStorageService, MessageService } from 'brainloper-ui';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { SocketWebService } from 'src/app/services/socket-web.service';
import { FormCompanyComponent } from '../form-company/form-company.component';
import { Company } from 'src/app/models/administration/company';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { Plan } from 'src/app/models/configuration/plan';
import { RefreshToken } from 'src/app/models/administration/refresh-token';


@Component({
    selector: 'app-modal-company',
    templateUrl: './modal-company.component.html',
    styleUrls: ['./modal-company.component.scss'],
    standalone: false
})
export class ModalCompanyComponent implements OnInit {
  private loginForm: UntypedFormGroup
  public baseUrl: String = `${EndpointDictionary.Base._BASE_URL_V2}`


  private urlCompanias: string = `${EndpointDictionary.Company.CRUD_COMPANY_DATA}`;
  private urlGenerateToken: string = `${EndpointDictionary.Security.GENERATE_TOKEN}`;
  private urlGetDetallePlan: string = `${EndpointDictionary.Plans.CRUD_PLANS}`
  public compania: Company;
  public controlNgSwitch: number;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data,
    private message: MessageService,
    private http: HttpService,
    private router : Router,
    private formBuilder: UntypedFormBuilder,
    private deleteItem: DeleteGenericService,
    private storage : LocalStorageService,
    private socketWebService : SocketWebService
  ) {
    this.loginForm = this.formBuilder.group({
      userId:'',
      password:''
    })
  }
  ngOnInit(): void {
    this.compania = this.data as Company;
    //this.compania.logo = `${environment.endpoint}${EndpointDictionary.base.BASE_URL}${this.compania.logo}`
    this.controlNgSwitch = this.compania.state;
  }

  async eliminarCompania() {
    let arrayDelete: Array<Company> = []
    arrayDelete.push(this.compania)
    let res =  await this.deleteItem.deleteD(arrayDelete, this.urlCompanias, "id", "Compañia",)
    if (res) {
      this.logoutAllUsers()
    }
  }

  editarCompania(_data: Company){
    const dialogRef = this.dialog.open(FormCompanyComponent, {
      width:'80%',
      data: _data
    }).afterClosed().subscribe((x) => {
      if (x) this.dialog.closeAll()
    })
  }

  public logoutAllUsers(){
    this.message.Warning('Advertencia', 'Desea sacar de session a todos los usuarios de la compania ' + this.storage.get<string>('companyName'), true).then( res => {
      if(res){
        this.socketWebService.emit('logout-user-by-comany', this.compania.id )
        this.dialog.closeAll()
      }
    })
  }

  public async handlerAlert(active:boolean){
    let res:GenericResponse = await this.http.putDataBody(`${this.urlCompanias}/${this.compania.id}/${active? 1 : 0}` , null)
    this.message.Info("", res.message).then((res) => {
      this.logoutAllUsers()
    })
  }

  async go(){
    this.message.openLoading('Cargando...', 'Verificando compañia')

    let body = {
        "name":  this.storage.get<string>('userName'),
        "userId": this.storage.get<string>('cedula'),
        "companyId": this.data.id,
        "role": this.storage.get<string>('rol'),
        "roleId": 1,
        "state": 1,
        "user": this.storage.get<string>('user')
    }

    let resPlan: BaseResponse<Array<Plan>> = await this.http.getDataPromise(`${this.urlGetDetallePlan}/${this.data.planId}`)
    let token: BaseResponse<RefreshToken>= await this.http.postDataPromise(this.urlGenerateToken, body)

    if(resPlan.code === 0 && token.code === 0){
      this.storage.set<Plan>('plan', resPlan.body[0])
      this.storage.set<string>('company' , this.data)
      this.storage.set<number>('id_compania' , this.data.id)
      this.storage.set<string>('companyName', `Root / ${this.data.name}`)
      this.storage.set<string>('token', token.body.token)
      this.storage.set<number>('refreshToken', token.body.refreshToken)
      this.router.navigate(['inicio'])
      this.dialog.closeAll()
      this.message.closeLoading()
    }else{
      let msg = ""
      if(resPlan.code != 0) msg = resPlan.message
      if(token.code != 0) msg = token.message
      this.message.Error('Error', msg)
      this.message.closeLoading()
    }


      }
    }
